"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = TextField;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shortid = _interopRequireDefault(require("shortid"));

var _stylesModule = _interopRequireDefault(require("./styles.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// const styles = {}
function TextField(_ref) {
  var className = _ref.className,
      display = _ref.display,
      helpText = _ref.helpText,
      id = _ref.id,
      invalid = _ref.invalid,
      label = _ref.label,
      onChange = _ref.onChange,
      renderLeft = _ref.renderLeft,
      renderRight = _ref.renderRight,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["className", "display", "helpText", "id", "invalid", "label", "onChange", "renderLeft", "renderRight", "size"]);

  var _useState = (0, _react.useState)(_shortid.default.generate()),
      _useState2 = _slicedToArray(_useState, 1),
      generatedId = _useState2[0];

  function handleChange(evt) {
    onChange(evt.target.value);
  }

  var idToUse = id || generatedId;
  return (/*#__PURE__*/_react.default.createElement("span", {
      style: {
        display: display,
        position: 'relative'
      }
    }, label && /*#__PURE__*/_react.default.createElement("label", {
      className: _stylesModule.default.label,
      htmlFor: idToUse
    }, label), renderLeft && /*#__PURE__*/_react.default.createElement("span", {
      className: _stylesModule.default.renderLeft
    }, renderLeft), /*#__PURE__*/_react.default.createElement("input", _extends({
      className: "".concat(_stylesModule.default.textbox, " ").concat(_stylesModule.default[size], " ").concat(invalid ? _stylesModule.default.invalid : '', " ").concat(className),
      id: idToUse,
      onChange: handleChange
    }, props)), renderRight && /*#__PURE__*/_react.default.createElement("span", {
      className: _stylesModule.default.renderRight
    }, renderRight), /*#__PURE__*/_react.default.createElement("div", {
      className: _stylesModule.default.helpText
    }, helpText))
  );
}

TextField.defaultProps = {
  className: '',
  disabled: false,
  display: 'inline-block',
  helpText: '',
  invalid: false,
  label: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  placeholder: '',
  readOnly: false,
  renderLeft: null,
  renderRight: null,
  size: 'standard',
  type: 'text'
};
TextField.propTypes = {
  autoComplete: _propTypes.default.bool,
  autoFocus: _propTypes.default.bool,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  display: _propTypes.default.oneOf(['block', 'inline-block']),
  invalid: _propTypes.default.bool,

  /** A message to show below the input */
  helpText: _propTypes.default.string,
  id: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.func]),
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,

  /** Content (like an icon) to render on the left side of the input */
  renderBefore: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),

  /** Content (like a button) to render on the right side of the input */
  renderAfter: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),

  /** Will set the html 'required' attribute on the input */
  required: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'standard', 'large']),

  /** Any additional styles you need to apply to the input */
  style: _propTypes.default.object,
  type: _propTypes.default.oneOf(['text', 'email', 'url', 'tel', 'search', 'password']),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
var _default = TextField;
exports.default = _default;